import React, { useContext, useEffect, useRef, useState } from 'react';
import Logo from "../../_asset/image/ROYALCASINO.png";
import casino from "../../_asset/image/Casino.png";
import { UserBtn, Userinfo } from "../pop_pages/user/user";
import CasinoModal from "../pop_pages/minigame/casino_popup";
import SlotModal from "../pop_pages/minigame/slot_popup";
import DepositModal from "../pop_pages/minigame/request_deposit";
import WithdrawalModal from "../pop_pages/minigame/request_withdrawal";
import { NoticeModal } from "../pop_pages/board/notice_popup";
import { actionContext } from "../../apps/page";
import ModalContainer from "./modal_container";
import commingSoonVideo from "../../_asset/media/comming_soon_circus.mp4"
import { Player } from '@lottiefiles/react-lottie-player';
import loading from '../../_asset/lottie/blackjack.json';
import { loadingContext } from "../provider/game_loading_provider";
import { PrivateUser } from "../../hooks/useUser";
import swal from "sweetalert"
import logoImage from "../../_asset/bg/hadeslogo2.png"
import logoImage2 from "../../_asset/bg/logoSmall.png"
import { isMobile } from 'react-device-detect';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import api from '../../util/api';

function Header() {
    const { User, MutateUser } = useContext(actionContext)
    const { SetLoadingPop } = useContext(loadingContext)
    const [whoamiLoadingState, setWhoamiLoadingState] = useState<boolean>(false)
    useEffect(() => {
        if (User) {
            SetLoadingPop(false)
            setWhoamiLoadingState(true)
        }
    }, [User])
    return (
        <header id={`header`} className={whoamiLoadingState ? "" : "whoami-loading-event-false"}>

            <div className={`header-top`}>
                <div className='header-container'>
                    <MobileNavigation />

                    {
                        User ? User.is_authenticated ? <Userinfo user={User} mutateUser={MutateUser} />
                            : <UserBtn />
                            : <></>
                    }
                </div>
            </div>
            <Navigation />
        </header>
    );
}

export default Header;

function MobileNavigation() {
    const [show, setShow] = useState<boolean>(false)

    return (
        <>
            <div className={`mobile-menu-btn ${show ? "active" : ""}`} onClick={e => setShow(!show)}>
                <div className='btn-layout'>
                    <FontAwesomeIcon icon={faBars} />
                </div>
            </div>
            <div className={`mobile-nav-container ${show ? "active" : ""}`}>
                <div className={`mobile-nav-modal ${show ? "active" : ""}`} onClick={e => setShow(false)}></div>
                <nav className={`mobile-nav ${show ? "active" : ""}`}>
                    <ul>
                        <OpenPopPage name={`라이브 카지노`} page={`live casino`}></OpenPopPage>
                        <OpenPopPage name={`슬롯머신`} page={`slot machine`}></OpenPopPage>
                        <OpenPopPage name={`홀덤`} page={`holdem`}></OpenPopPage>
                        {/* <OpenPopPage name={`미니게임`} page={`minigame`}></OpenPopPage> */}
                        <OpenPopPage name={`입금신청`} page={`deposit`}></OpenPopPage>
                        <OpenPopPage name={`출금신청`} page={`withdrawal`}></OpenPopPage>
                        <OpenPopPage name={`공지사항`} page={`notice`}></OpenPopPage>
                    </ul>
                </nav>
            </div>
        </>
    )
}

export function SiteLogo() {
    return (
        <div className="logo" onClick={e => window.location.href = '/'}>
            <img src={logoImage} alt='logo' />
            {/* <div className={`logo-top`}>
                <img src={Logo}   alt="logo"/>
            </div>
            <div className={`logo-bot`}>
                <img src={casino} alt="logo"/>
            </div> */}
        </div>
    )
}
export function SiteLogo2() {
    return (
        <div className="logo" onClick={e => window.location.href = '/'}>
            <img src={logoImage2} alt='logo' />
        </div>
    )
}

function Navigation() {

    return (
        <>
            <nav className="header-nav">
                <ul>
                    <OpenPopPage name={`라이브 카지노`} page={`live casino`}></OpenPopPage>
                    <OpenPopPage name={`슬롯머신`} page={`slot machine`}></OpenPopPage>
                    <OpenPopPage name={`홀덤`} page={`holdem`}></OpenPopPage>
                    {/* <OpenPopPage name={`미니게임`} page={`minigame`}></OpenPopPage> */}
                    {/*<OpenPopPage name={`1:1문의`}></OpenPopPage>*/}
                    {/*<OpenPopPage name={`쪽지(0)`}></OpenPopPage>*/}
                </ul>
                <div className='logo-layout'>
                    <SiteLogo />
                </div>
                <ul>
                    <OpenPopPage name={`입금신청`} page={`deposit`}></OpenPopPage>
                    <OpenPopPage name={`출금신청`} page={`withdrawal`}></OpenPopPage>
                    <OpenPopPage name={`공지사항`} page={`notice`}></OpenPopPage>
                </ul>
            </nav>
        </>
    )
}

type popPageTypes = "live casino" | "slot machine" | "reel game" | "holdem" | "minigame" | "deposit" | "withdrawal" | "notice";
type gameItemsClassType = "" | "disabled" | "focus"
function OpenPopPage({ page, name }: { page: popPageTypes, name: string, }) {
    const [pageShow, setPageShow] = useState<boolean>(false)
    const { SetLoginPop } = useContext(actionContext)
    const { User } = useContext(actionContext)
    const itemRef = useRef<HTMLLIElement>(null)

    let ModalPage: React.ReactNode;
    switch (page) {
        case "live casino":
            ModalPage = <CasinoModal popShow={pageShow}
                setPopShow={setPageShow} />;
            break;
        case "slot machine":
            ModalPage = <SlotModal popShow={pageShow}
                setPopShow={setPageShow} />;
            break;
        case "reel game":
            ModalPage = <CommingSoonModal popShow={pageShow}
                setPopShow={setPageShow} />;
            break;
        case "holdem":
            ModalPage = <CommingSoonModal popShow={pageShow}
                setPopShow={setPageShow} />;
            break;
        case "minigame":
            ModalPage = <CommingSoonModal popShow={pageShow}
                setPopShow={setPageShow} />;
            break;
        case "deposit":
            ModalPage = <DepositModal popShow={pageShow}
                setPopShow={setPageShow} />;
            break;
        case "withdrawal":
            ModalPage = <WithdrawalModal popShow={pageShow}
                setPopShow={setPageShow} />;
            break;
        case "notice":
            ModalPage = <NoticeModal popShow={pageShow}
                setPopShow={setPageShow} />;
            break;
    }


    function holdemGetLink() {
        api(`/api/game/games/link/realpoker`)
            .then(res => res.json())
            .then((data: { link: string }) => {
                if (data?.link) {
                    window.open(data.link, 'holdem pop', 'width=1200 height=640')
                }
            })
            .catch((res: Response) => {
                ErrorHandler(res)
            })
    }
    async function ErrorHandler(res: Response) {
        const message = await res.json()
        swal({
            text: message,
            icon: "error"
        })
    }
    function openPagePop() {
        // setPageShow(true)
        if (User?.is_authenticated) {
            // if (page == 'holdem') {
            //     holdemGetLink()
            // } else {
            //     setPageShow(true)
            // }
            setPageShow(true)

        } else {
            SetLoginPop()
        }
    }

    return (
        <>
            <li ref={itemRef} onClick={openPagePop}>
                <p className={`${page}`}></p>
                <span>{name}</span>
            </li>
            {ModalPage}
        </>
    )
}
OpenPopPage.defaultProps = {
    page: ""
}


function CommingSoonModal({ popShow, setPopShow }: { popShow: boolean; setPopShow: Function; }) {
    return (
        <ModalContainer
            show={popShow}
            setShow={setPopShow}
            className={"comming-soon-modal"}
        >
            {/*<video src={commingSoonVideo} muted autoPlay loop />*/}
            <div className={'comming-soon-message'}>
                <Player src={loading}
                    loop
                    autoplay
                    style={{ width: "22rem", height: "22rem" }}></Player>
                <p>점검중 입니다...</p>
            </div>
        </ModalContainer>
    )
}